import reduce from 'lodash/reduce';
import { moment } from '@eb/date';

import { trackEventClickInternal } from './api/analytics';
import {
    FILTER_TYPE_GA_MAP,
    CUSTOM_DATE,
    EVENTBRITE_CATEGORY_TO_REFINEMENT,
    GA_SEARCH_CATEGORY,
    EVENTBRITE_FORMAT_TO_REFINEMENT,
} from './constants';

/* Internal Tracking */
export const trackInternalAppClick = (trackingData) => {
    const defaultData = {
        platform: 'web',
        timestamp: parseInt(moment().format('X'), 10),
        selectionType: 'event',
    };

    trackEventClickInternal({ ...defaultData, ...trackingData });
};

/*
 * @param selectedFilter -- object -- ${filterType}: ${filterValue}
 *      - Filter object passed to search API upon selection
 * @param customDate -- object -- {startDate: 'string', endDate: 'string'}
 *      - Optional param that exists when filterValue === CUSTOM_DATE
 * @param category -- string
 *      - Future proof support for if filters need to be associated to category other than search
 *
 * Function takes in filter selection information and creates the necessary anayltics tracking
 * body from it for GA tracking
 */
export const getFilterEventTrackingData = (
    selectedFilter,
    customDate,
    category = GA_SEARCH_CATEGORY,
) =>
    reduce(
        selectedFilter,
        (memo, filterValue, filterType) => {
            if (filterValue || filterValue === '') {
                if (filterType in FILTER_TYPE_GA_MAP) {
                    let label = filterValue;
                    const filterAnalyticsAction =
                        FILTER_TYPE_GA_MAP[filterType];

                    //Special case for customDate
                    if (filterValue === CUSTOM_DATE) {
                        const { startDate, endDate } = customDate;

                        label = `${startDate}--${endDate}`;
                    }

                    //Special case for category
                    if (EVENTBRITE_CATEGORY_TO_REFINEMENT[filterValue]) {
                        label = EVENTBRITE_CATEGORY_TO_REFINEMENT[filterValue];
                    }

                    //Special case for format
                    if (EVENTBRITE_FORMAT_TO_REFINEMENT[filterValue]) {
                        label = EVENTBRITE_FORMAT_TO_REFINEMENT[filterValue];
                    }

                    return [
                        ...memo,
                        {
                            category,
                            label,
                            action: filterAnalyticsAction,
                        },
                    ];
                }
            }

            return memo;
        },
        [],
    );
